import {BaseObject} from './BaseObject';

export class ProductTransfer extends BaseObject {

    productId: number;
    count: number;
    userId = 1;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/ProductTransfer.ts